import { Add, Close, Edit, Save } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';

type AllButtonProps = ButtonProps & {
  label: string;
  onClickHandler: () => void;
  'data-testid'?: string;
};

export const AddButton = (props: AllButtonProps) => {
  const { onClickHandler, label, ...restProps } = props;
  return (
    <Button
      startIcon={<Add />}
      variant="contained"
      onClick={onClickHandler}
      sx={{
        minHeight: { xs: '44px', sm: '36px' },
        fontSize: { xs: '16px', sm: '14px' },
        ...restProps.sx,
      }}
      {...restProps}
    >
      {label}
    </Button>
  );
};

export const CancelButton = (props: AllButtonProps) => {
  const { onClickHandler, label, ...restProps } = props;
  return (
    <Button
      startIcon={<Close />}
      variant="outlined"
      onClick={onClickHandler}
      sx={{
        minHeight: { xs: '44px', sm: '36px' },
        fontSize: { xs: '16px', sm: '14px' },
        ...restProps.sx,
      }}
      {...restProps}
    >
      {label}
    </Button>
  );
};

export const EditButton = (props: AllButtonProps) => {
  const { onClickHandler, label, ...restProps } = props;
  return (
    <Button
      startIcon={<Edit />}
      variant="contained"
      onClick={onClickHandler}
      sx={{
        minHeight: { xs: '44px', sm: '36px' },
        fontSize: { xs: '16px', sm: '14px' },
        ...restProps.sx,
      }}
      {...restProps}
    >
      {label}
    </Button>
  );
};

export const SaveButton = (props: AllButtonProps) => {
  const { onClickHandler, label, ...restProps } = props;
  return (
    <Button
      startIcon={<Save />}
      variant="contained"
      onClick={onClickHandler}
      sx={{
        minHeight: { xs: '44px', sm: '36px' },
        fontSize: { xs: '16px', sm: '14px' },
        ...restProps.sx,
      }}
      {...restProps}
    >
      {label}
    </Button>
  );
};
